import {ref} from 'vue'

export default function ContextMenuOpener(default_position?: string): any {

    const index = ref('_');
    const position = ref(default_position || 'top-right');
    const rect = ref({
        right: 0,
        top: 0,
        width: 0,
        bottom: 0,
    });
    const style = ref({
        left: '0',
        top: '0'
    });

    const open = (event: any, i: string) => {
        rect.value = event.currentTarget.getBoundingClientRect()
        index.value = i
    }

    const isVisible = (i: string) => {
        return i == index.value
    }

    const setVisible = (i: string) => {
        index.value = i
    }

    const close = () => {
        index.value = '_'
    }

    const refreshPosition = (el: any) => {
        const el_rect = el.getBoundingClientRect()
        let top;
        switch (position.value) {
            case 'top-right':
                style.value.left = `${rect.value.right - el_rect.width}px`
                top = rect.value.top
                if (rect.value.top + el_rect.height > innerHeight) {
                    top = rect.value.bottom - el_rect.height
                }
                style.value.top = `${top}px`
                break
            case 'top-left':
                style.value.left = `${rect.value.right - rect.value.width}px`
                top = rect.value.top
                if (rect.value.top + el_rect.height > innerHeight) {
                    top = rect.value.bottom - el_rect.height
                }
                style.value.top = `${top}px`
                break
        }

    }


    return {
        index,
        position,
        style,
        open,
        close,
        refreshPosition,
        isVisible,
        setVisible,
    }
}
